import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import MovieCard from '@/components/base/MovieCard';
import CategoryNav from '@/pages/home/components/CategoryNav';
import { categories, getMoviesByCategory } from '@/mocks/movies';

const categoryNames: Record<string, string> = {};
categories.forEach(c => { categoryNames[c.slug] = c.name; });

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'all';
  const movies = getMoviesByCategory(currentSlug);
  const categoryName = categoryNames[currentSlug] || '全部';

  return (
    <>
      <Navbar />
      <main className="pt-20 pb-16">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: currentSlug === 'all' ? '全部电影' : categoryName },
            ]}
          />

          <div className="bg-background-100 rounded-xl p-4 md:p-6 mb-8">
            <CategoryNav active={currentSlug} />
          </div>

          <div className="flex items-center justify-between mb-6">
            <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              {categoryName}
            </h1>
            <span className="text-sm text-foreground-500">共 {movies.length} 部</span>
          </div>

          {movies.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
              {movies.map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-200 rounded-full">
                <i className="ri-film-line text-foreground-400 text-2xl"></i>
              </div>
              <p className="text-foreground-500">该分类暂无电影</p>
            </div>
          )}
        </div>
      </main>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": `${categoryName} - 6080电影网`,
            "description": `6080电影网${categoryName}分类，为您提供最新${categoryName}在线观看，高清画质不缓冲，免费无广告。`,
            "url": `https://6080dy.com/category/${currentSlug}`,
            "isPartOf": {
              "@type": "WebSite",
              "name": "6080电影网",
              "url": "https://6080dy.com",
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://6080dy.com" },
                { "@type": "ListItem", "position": 2, "name": categoryName },
              ],
            },
          }),
        }}
      />
      <Footer />
    </>
  );
}